// MultiCourtInfo — ActivityWizard Steg 3 (delspår multi-bana). Info-rad (ej input). Visar
// nu KORREKT "X spelare = N banor" eftersom spelarantal är känt från steg 2 (löser 3d-knuten
// där spelarantal var okänt i bana-steget). N kommer från deriveRequiredCourts (single source
// of truth, ej egen ceil). Varnar om N överskrider auto-poolens kapacitet (defensivt — steg-2-
// cappen ska redan förhindra det).

import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

const PADEL_MAX_PER_COURT = 4;

interface MultiCourtInfoProps {
  players: number;
  requiredCourts: number;
  autoPoolSize: number;
}

export default function MultiCourtInfo({ players, requiredCourts, autoPoolSize }: MultiCourtInfoProps) {
  const { t } = useTranslation("admin");
  const overCapacity = requiredCourts > autoPoolSize;
  const capacity = autoPoolSize * PADEL_MAX_PER_COURT;

  return (
    <p
      data-testid="multi-court-info"
      className={cn(
        "rounded-xl border px-3 py-2.5 text-xs",
        overCapacity
          ? "border-destructive/30 bg-destructive/5 text-destructive"
          : "border-primary/20 bg-primary/5 text-muted-foreground",
      )}
    >
      {overCapacity
        ? t("activityWizard.step3.capacityWarning", {
            players,
            max: capacity,
            defaultValue: `${players} spelare överskrider hallens kapacitet (${capacity})`,
          })
        : t("activityWizard.step3.multiCourtInfo", {
            players,
            courts: requiredCourts,
            defaultValue: `${players} spelare = ${requiredCourts} banor`,
          })}
    </p>
  );
}
